import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { TableCell } from '../../../index/RecentSalesActivitySection/RecentActivitySubSection/Components/TableCell'
import { dataExportsProxy } from '../dataExportsProxy'
import { buildAppDataExportsPath } from '../../../../../pages/app/data-exports/[id]'
import DataExportStatusLabel from '../../../../../shared/components/ui/DataExportStatusLabel'
import { GlobalDataExportStatus } from '../../../../../shared/types/GlobalDataExportStatus'
import { JsonPropertyLine } from '../../../../../shared/components/ui/JsonPropertyLine'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import {
  TableCellNoLink
} from '../../../index/RecentSalesActivitySection/RecentActivitySubSection/Components/TableCellNoLink'

export function DataExportsTableRows (): ReactElement {
  const { dataExports } = useSnapshot(dataExportsProxy)
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <>
      {dataExports.length === 0 && (
        <tr>
          <td colSpan={10}>
            <div className="text-center my-16 text-wpy-gray">
              No Results
            </div>
          </td>
        </tr>
      )}
      {dataExports.map((dataExport, i) => {
        const notLastRow = i !== (dataExportsProxy.dataExports.length - 1)
        const path = buildAppDataExportsPath(dataExport.id)
        return (
          <tr
            key={dataExport.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell path={path}>
              <DataExportStatusLabel status={dataExport.status || GlobalDataExportStatus.Pending} />
            </TableCell>
            <TableCell path={path}>
              {dataExport.type}
            </TableCell>
            <TableCell path={path}>
              <JsonPropertyLine jsonString={dataExport.filters} />
            </TableCell>
            <TableCell path={path}>
              {dataExport.fileCount}
            </TableCell>
            <TableCellNoLink>
              {dataExport.files.length > 0 &&
                <a href={dataExport.files[0].signedUrl} target="_blank" rel="noopener noreferrer" key={i}>
                  <button className={cn(buttonColors.classes, 'rounded my-2 py-2 px-4 mx-2 text-white cursor-pointer')}>Download File </button>
                </a>}
            </TableCellNoLink>
            <TableCell path={path}>
              {dataExport.id}
            </TableCell>
          </tr>
        )
      })}
    </>
  )
}
